<aa-qna-cookie-banner></aa-qna-cookie-banner>
<div class="wrapper">
  <div class="content scrollbar-fix">
    <!-- <a href="#main-content" class="govuk-skip-link">Skip to main content</a> -->

    <header class="govuk-header" role="banner" data-module="header">
      <div class="govuk-header__container govuk-width-container theme-border">
        <div class="govuk-header__logo">
          <img [src]="meta.logoImage" [alt]="meta.teamName">
        </div>
      </div>

      <!-- Beta only shown on pages with "showBanner" flag -->
      <div class="govuk-phase-banner-container govuk-width-container" *ngIf="meta.treeStatus === TreeStatus.Beta && showBanner">
        <div class="govuk-phase-banner noprint">
          <p class="govuk-phase-banner__content">
            <strong class="govuk-tag govuk-phase-banner__content__tag theme-background-color">beta</strong>
            <span class="govuk-phase-banner__text">This is a new service – your <a [href]="meta.feedbackLink" target="_blank">feedback</a> will help us to improve it.</span>
          </p>
        </div>
      </div>

      <!-- Demo status ignore the "showBanner" flag -->
      <div class="govuk-phase-banner-container govuk-width-container" *ngIf="meta.treeStatus === TreeStatus.Demo">
        <div class="govuk-phase-banner noprint">
          <p class="govuk-phase-banner__content">
            <strong class="govuk-tag govuk-phase-banner__content__tag theme-background-color">demo</strong>
            <span class="govuk-phase-banner__text">This service is still under construction</span>
          </p>
        </div>
      </div>
    </header>

    <div class="govuk-width-container" [ngClass]="{'hotjar-container': hotjarEnabled}">
      <aa-breadcrumb-nav></aa-breadcrumb-nav>

      <main class="govuk-main-wrapper " id="main-content" role="main">

        <!-- Error -->
        <ng-container *ngIf="navigation.error; else noError">
          <h1 class="govuk-heading-xl">Sorry! An error has occurred</h1>
          <h2 class="govuk-heading-m">Please check your internet connection and reload the page</h2>
        </ng-container>

        <!-- No Error -->
        <ng-template #noError>

          <!-- Data Available -->
          <ng-container *ngIf="navigation.data; else loading">
            <router-outlet></router-outlet>

            <div class="govuk-grid-row">
              <div class="govuk-grid-column-two-thirds">
                <a *ngIf="showBackButton" (click)="navigation.back()" href='#' class="govuk-back-link noprint">Back</a>

                <ng-container *ngIf="showDisclaimer">
                  <p class="govuk-body-s govuk-!-margin-top-2 disclaimer">
                    {{navigation.meta.disclaimer}}
                    <ng-container *ngIf="meta.treeType==TreeType.AdvisorFreemium">
                      <a href="https://www.adviceaid.uk/" class="print-expand" target="_blank" title="Find out more about AdviceAid">Find out more</a>.
                    </ng-container>
                  </p>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Loading -->
          <ng-template #loading>
            <aa-spinner></aa-spinner>
          </ng-template>
        </ng-template>

        <aa-advice-footer class="printonly" aria-hidden="true" [meta]="meta"></aa-advice-footer>

        <div class="printonly print-footer">
          <aa-copyright></aa-copyright>
        </div>
      </main>
    </div>
  </div>

  <footer class="govuk-footer scrollbar-fix noprint" role="contentinfo">

    <div class="govuk-width-container ">
      <div class="govuk-footer__meta">
        <div class="govuk-footer__meta-item noprint">

          <h2 class="govuk-visually-hidden">Support links</h2>
          <ul class="govuk-footer__inline-list">

            <!-- Start -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" routerLink="/start">
                Start
              </a>
            </li>

            <!-- Contact -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" [href]="meta.contactLink" *ngIf="meta.contactLink; else defaultContact">
                Contact
              </a>

              <ng-template #defaultContact>
                <a class="govuk-footer__link" routerLink="/contact">
                  Contact
                </a>
              </ng-template>
            </li>

            <!-- Accessibility -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" routerLink="/accessibility">
                Accessibility
              </a>
            </li>

            <!-- Cookies -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" routerLink="/cookies">
                Cookies
              </a>
            </li>

            <!-- Privacy policy -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" [href]="meta.privacyLink" *ngIf="meta.privacyLink; else defaultPrivacy">
                Privacy policy
              </a>

              <ng-template #defaultPrivacy>
                <a class="govuk-footer__link" routerLink="/privacy">
                  Privacy policy
                </a>
              </ng-template>
            </li>

            <!-- Languages -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" routerLink="/languages">
                Languages
              </a>
            </li>

            <!-- Safety -->
            <li class="govuk-footer__inline-list-item">
              <a class="govuk-footer__link" routerLink="/safety">
                Safety
              </a>
            </li>
          </ul>
        </div>

        <div class="govuk-footer__meta-item" aria-hidden="true">
          <div class="govuk-footer__licence-description">Powered by</div>
            <img class="logo" [src]="'adviceaid_logo.png' | imageSrc" alt="AdviceAid">
            <aa-copyright></aa-copyright>
        </div>
      </div>
    </div>
  </footer>
</div>

